import { render, staticRenderFns } from "./TransferTask.vue?vue&type=template&id=57a8ee8a&scoped=true"
import script from "./TransferTask.vue?vue&type=script&lang=js"
export * from "./TransferTask.vue?vue&type=script&lang=js"
import style0 from "./TransferTask.vue?vue&type=style&index=0&id=57a8ee8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8ee8a",
  null
  
)

export default component.exports